module.exports = __webpack_public_path__ + "images/guangxi_banner02.jpg?f7a820f9b899d6e51108eaf5d9cc9fb6";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/guangxi_banner02.jpg
// module id = 184
// module chunks = 1